/**
 * Order Service
 * Handles order creation and management
 */

import { api, ApiResponse } from './api';
import { Order } from './adminService';

export interface CreateOrderData {
  products: {
    productId: string;
    quantity: number;
    price: number;
  }[];
  deliveryAddress: {
    fullName: string;
    phone: string;
    address: string;
    county: string;
    town: string;
  };
  deliveryMethod: 'delivery' | 'pickup';
  paymentMethod: 'mpesa' | 'cash' | 'card';
  notes?: string;
}

export interface PaymentInitiationResponse {
  checkoutRequestId: string;
  merchantRequestId: string;
  responseCode: string;
  responseDescription: string;
  customerMessage: string;
}

class OrderService {
  /**
   * Create new order
   */
  async createOrder(orderData: CreateOrderData): Promise<ApiResponse<Order>> {
    return api.post<Order>('/orders', orderData);
  }

  /**
   * Get user's orders
   */
  async getMyOrders(): Promise<ApiResponse<Order[]>> {
    return api.get<Order[]>('/orders');
  }

  /**
   * Get specific order
   */
  async getOrder(orderId: string): Promise<ApiResponse<Order>> {
    return api.get<Order>(`/orders/${orderId}`);
  }

  /**
   * Cancel order
   */
  async cancelOrder(orderId: string, reason?: string): Promise<ApiResponse<Order>> {
    return api.put<Order>(`/orders/${orderId}/cancel`, { reason });
  }

  /**
   * Initiate M-Pesa payment
   */
  async initiateMpesaPayment(orderId: string, phoneNumber: string): Promise<ApiResponse<PaymentInitiationResponse>> {
    return api.post<PaymentInitiationResponse>('/payments/mpesa/stk-push', {
      orderId,
      phoneNumber,
    });
  }

  /**
   * Check payment status
   */
  async checkPaymentStatus(checkoutRequestId: string): Promise<ApiResponse<any>> {
    return api.post('/payments/mpesa/query', { checkoutRequestId });
  }

  /**
   * Confirm order delivery
   */
  async confirmDelivery(orderId: string): Promise<ApiResponse<Order>> {
    return api.put<Order>(`/orders/${orderId}/confirm-delivery`, {});
  }
}

export const orderService = new OrderService();

